import {heartSvg as Icon__small__heartSvg} from '../Icon__small/Icon__small--heart.js'

export var heart = {
  name: 'heart',
  category: 'icon',
  colorable: true,
  svg: Icon__small__heartSvg,
};
